import { cn } from "@jana-technology/platform-ui";
import { ChartCardProps } from "./types";
import { LoadingSpinner } from "components/loaders";

export const ChartCard = ({
  className,
  heading,
  children,
  loading,
  loaderClassName = "h-[669px] w-full",
}: ChartCardProps) => {
  return (
    <div className={cn("rounded shadow-table", className)}>
      <div className="border-b-2 border-b-grey-300">
        <h2 className="px-6 py-5 font-semibold">{heading}</h2>
      </div>
      <div className="px-6 py-5">
        <LoadingSpinner loading={loading} className={cn(loaderClassName)}>
          {children}
        </LoadingSpinner>
      </div>
    </div>
  );
};

export default ChartCard;
